import { ControlsOf, FormGroupType } from '@app/core/utils/formgroup-type';
import { MeteringPointsCharacteristic } from '@app/api/dmc';
import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createDetailCharacteristicsForm(): FormGroupType<MeteringPointsCharacteristic> {
  return new FormGroup<ControlsOf<MeteringPointsCharacteristic>>({
    assetType: new FormControl({ value: null, disabled: true }),
    capacity: new FormControl({ value: null, disabled: true }),
    connectionType: new FormControl({ value: null, disabled: true }),
    disconnectionType: new FormControl({ value: null, disabled: true }),
    maximumCurrent: new FormControl(),
    maximumPower: new FormControl(),
    meterReadingOccurrence: new FormControl(null, Validators.required),
    meteringPointType: new FormControl(null, Validators.required),
    netSettlementGroup: new FormControl({ value: null, disabled: true }),
    powerPlantIdentification: new FormControl({ value: null, disabled: true }),
    productCharacteristicIdentification: new FormControl(null, Validators.required),
    productCharacteristicUnitType: new FormControl(null, Validators.required),
    readingCharacteristics: new FormControl(),
    settlementMethod: new FormControl(),
    subType: new FormControl(null, Validators.required),
    locationDescription: new FormControl(),
    fromGridAreaId: new FormControl(),
    toGridAreaId: new FormControl(),
  });
}
